import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import moment from "moment";

const PunchStatusChip = ({ punches = [], shiftName }) => {
  if (!punches || punches.length === 0) {
    return null;
  }

  // Check if there are any complete punches (both timeIn and timeOut)
  const hasCompletePunches = punches.some((punch) => punch.timeIn && punch.timeOut);
  const hasIncompletePunches = punches.some((punch) => punch.timeIn && !punch.timeOut);

  // Get the most recent punch
  const latestPunch = punches[punches.length - 1];
  const clockInTime = latestPunch?.timeIn
    ? moment(latestPunch.timeIn).format("MMM D, YYYY h:mm A")
    : null;
  const clockOutTime = latestPunch?.timeOut
    ? moment(latestPunch.timeOut).format("MMM D, YYYY h:mm A")
    : null;

  if (hasCompletePunches) {
    return (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <Tooltip title={clockInTime ? `Has clocked in at ${clockInTime}` : "Has clocked in"} arrow>
          <Chip
            label="CLOCK IN"
            size="small"
            color="success"
            sx={{
              fontWeight: "bold",
              fontSize: "0.70rem",
              height: "18px",
              minWidth: "50px",
              borderRadius: "6px",
              px: 1,
              color: "#fff",
              backgroundColor: "#43a047",
              "&:hover": { backgroundColor: "#388e3c" },
            }}
          />
        </Tooltip>
        <Tooltip
          title={clockOutTime ? `Has clocked out at ${clockOutTime}` : "Has clocked out"}
          arrow
        >
          <Chip
            label="CLOCK OUT"
            size="small"
            sx={{
              fontWeight: "bold",
              fontSize: "0.70rem",
              height: "18px",
              minWidth: "50px",
              borderRadius: "6px",
              px: 1,
              color: "#fff",
              backgroundColor: "#e53935",
              "&:hover": { backgroundColor: "#b71c1c" },
            }}
          />
        </Tooltip>
      </Box>
    );
  }
  if (hasIncompletePunches) {
    return (
      <Tooltip
        title={clockInTime ? `Has clocked in at ${clockInTime}` : "Has clocked in but not out"}
        arrow
      >
        <Chip
          label="CLOCK IN"
          size="small"
          color="success"
          sx={{
            fontWeight: "bold",
            fontSize: "0.70rem",
            height: "18px",
            minWidth: "50px",
            borderRadius: "6px",
            px: 1,
            color: "#fff",
            backgroundColor: "#43a047",
            "&:hover": { backgroundColor: "#388e3c" },
          }}
        />
      </Tooltip>
    );
  }

  return null;
};

export default PunchStatusChip;
